// extracted by mini-css-extract-plugin
export default {"container":"NotificationsTable_component_container__o3iLs","downloadIcon":"NotificationsTable_component_downloadIcon__eUmVR"};